<template>
	<div class="gw-box shadow">
		<div class="gw-box-header">
			<h4>Testimonials</h4>
		</div>
		<div class="gw-box-body">
			<div v-for="(testimonial, i) in testimonials" :key="i">
				<p>"{{testimonial.quote}}"</p>
				<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>-{{testimonial.author}}</i></p>
				<div class="gw-hr" v-if="i+1 < testimonials.length"></div>
			</div>
		</div>
		<div class="gw-box-footer align-content-center">
			<h5>Write your own review on <a href="https://www.theknot.com/marketplace/aimeeontheharp-glen-burnie-md-728801">TheKnot</a> or <a href="https://www.weddingwire.com/shared/rate/new?vid=af7fd18c6a4f7da0">WeddingWire</a>!</h5>
		</div>
	</div>
</template>

<script>
export default {
  name: 'Testimonials',
  data () {
    return {
			/**
			 * @gui-admin
			 * list
			 * 
			 * @gui-admin-params
			 * quote: string
			 * author: string
			 */
			testimonials: [{
				quote: 'Aim\u00E9e was an absolute dream to work with and her harp music completed the vision I had for my Alice in Wonderland themed wedding. She learned a new song... upon request, and played many different samples of her musical repertoire during our initial meeting... She was very flexible... and was always available for me... Aim\u00E9e is professional and such a joy to work with! The icing on the cake: Aim\u00E9e showed up to the wedding... dressed to perfection for the Wonderland theme. I would highly recommend Aim\u00E9e and her beautiful music!',
				author: 'Aimme Biedzynski, a Bride in Towson, Maryland'
			},{
				quote: 'It\'s too bad the Catholic Church doesn\'t believe in cloning. Because then we could have an Aim\u00E9e of our own!',
				author: 'A Priest in West Virginia, after hearing Aim\u00E9e perform'
			},{
				quote: 'We already put money on another harpist, but we\'ll go ahead with you and lose our deposit. I really want you to play for my wedding!',
				author: 'A pleased Bride'
			},{
				quote: 'Listening to her play was the most well spent half hour I\'ve had in a long time.',
				author: 'A Guest at a wedding'
			}]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
